import { render, staticRenderFns } from "./Fkdialog.vue?vue&type=template&id=35bf1560&scoped=true"
import script from "./Fkdialog.vue?vue&type=script&lang=js"
export * from "./Fkdialog.vue?vue&type=script&lang=js"
import style0 from "./Fkdialog.vue?vue&type=style&index=0&id=35bf1560&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf1560",
  null
  
)

export default component.exports